import Typography from "@mui/material/Typography";
import type { SxProps } from "@mui/system";
import type { Theme } from "@mui/material/styles";

interface CustomerLyricsDisplayProps {
  lyrics: string;
  sx?: SxProps<Theme>;
}

export default function CustomerLyricsDisplay({
  lyrics,
  sx,
}: CustomerLyricsDisplayProps) {
  //remove all [bracket] annotations from lyrics
  let cleanedLyrics = lyrics.replace(/\[.*?\]/g, "").trim();
  //and also all (bracket) annotations, with optional surrounding asterisks e.g. *(text)*
  cleanedLyrics = cleanedLyrics.replace(/\*?\(.*?\)\*?/g, "").trim();
  //if there are more than 3 new lines in a row, reduce them to 2 new lines
  cleanedLyrics = cleanedLyrics.replace(/\n{3,}/g, "\n\n");

  return (
    <Typography
      variant="body1"
      sx={{
        whiteSpace: "pre-wrap",
        ...sx,
      }}
    >
      {cleanedLyrics}
    </Typography>
  );
}
